import { admin2 } from '@/api/instance'

export const FindShutDownNotice = async () => {
  return await admin2({
    method: 'get',
    url: '/shutdownNotice',
  })
}
